import React from 'react'
import { Well } from '@pushly/aqe/lib/components'
import { useService } from '@pushly/aqe/lib/hooks/use-service'
import { AppState } from '../../../../stores/app'
import { observer } from 'mobx-react'

export const CustomPromptPreviewStub = observer(() => {
    const { documentationLink } = useService(AppState)

    return (
        <div className="snippet-wrapper">
            <Well className="custom-prompt-snippets" hideFooter={true} hideHeader={true}>
                <h3>Instructions</h3>

                <div>
                    For more information on how to set up your custom prompt please visit our{' '}
                    <a href={`${documentationLink}/#manually-triggering-the-opt-in-prompt`} target="_blank">
                        Developer Documentation
                    </a>
                    .
                </div>
            </Well>
        </div>
    )
})
